import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule, RouterLink, MatCardModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  template: `
    <div class="login-page">
      <mat-card class="login-card">
        <h1>Email verification</h1>
        @if (loading()) {
          <mat-spinner diameter="36"></mat-spinner>
        } @else if (error()) {
          <div class="error-banner">{{ error() }}</div>
        } @else {
          <div class="success-banner">{{ message() }}</div>
        }
        <div class="auth-links"><a routerLink="/login">Go to sign in</a></div>
      </mat-card>
    </div>
  `,
  styleUrl: '../login/login.component.scss'
})
export class VerifyEmailComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  readonly loading = signal(true);
  readonly error = signal<string | null>(null);
  readonly message = signal<string | null>(null);

  ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email') ?? '';
    const token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!email || !token) {
      this.loading.set(false);
      this.error.set('Missing verification parameters.');
      return;
    }

    this.auth.verifyEmail({ email, token }).subscribe({
      next: (msg) => {
        this.loading.set(false);
        this.message.set(msg);
      },
      error: (err) => {
        this.loading.set(false);
        this.error.set(err?.error?.message || err?.message || 'Verification failed.');
      }
    });
  }
}
